import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AsuSmrReportFilters } from '../types/AsuSmrReportFilters';
import { AsuSMRDeatils } from "../types/AsuSMRDeatils";
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2PortalAsuSmrReportService } from '../o2-portal-asu-smr-report.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { Utility } from "src/app/common/service/utility";

@Component({
  selector: 'app-asu-smr-details',
  templateUrl: './asu-smr-details.component.html',
  styleUrls: ['./asu-smr-details.component.scss']
})
export class AsuSmrDetailsComponent implements OnInit {

  @Input() asuAndHYCOInvestmentFilters: AsuSmrReportFilters;
  isLoadPanelVisible: boolean = false;
  showGrid: boolean = false;
  dataSource: any;
  readonly allowedPageSizes = [10, 20, 50, 100, 200];
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  constructor(private notificationService: NotificationService,
    private utility: Utility,
    private o2PortalAsuSmrReportService: O2PortalAsuSmrReportService) {
  }

  ngOnInit(): void {
    this.getASUAndHYCOInvestmentDetailsReportData(this.asuAndHYCOInvestmentFilters);
  }

  getASUAndHYCOInvestmentDetailsReportData(asuAndHYCOInvestmentFilters) {
    if (asuAndHYCOInvestmentFilters) {
      this.isLoadPanelVisible = true;
      this.o2PortalAsuSmrReportService.getASUAndHYCOInvestmentDetailsReportData(asuAndHYCOInvestmentFilters).subscribe({
        next: compressedData => {
          var decompressedData = this.utility.decompressData(compressedData);
          var data: AsuSMRDeatils[] = JSON.parse(decompressedData);
          this.showGrid = true;
          this.dataSource = data;
          this.isLoadPanelVisible = false;
        },
        error: (error: any) => {
          this.isLoadPanelVisible = false;
          this.notificationService.alert("error", "Error while fetching Asu and HyCO investment details. ", error);
        }
      });
    }
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  exportExcel(e) {
    this.isLoadPanelVisible = true;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AsuSMRDetails.xlsx');
        });
    }).then(() => {
      this.isLoadPanelVisible = false;
    });
    e.cancel = true;
  }

}
